// extracted by mini-css-extract-plugin
export default {"body":"App_body__c3hD1","content":"App_content__lm6sn"};